import { Exclude, Expose, Type } from 'class-transformer';
import { BaseModel, PersonnelAttachmentSection } from '@core/data-access';
import { UploadFileControl, UploadFileModel } from '@portal/upload-file/data-access';
import { Default } from '@core/util';
import { AttachmentAttrKey } from '../type';

@Exclude()
export class AttachmentAttrModel extends BaseModel {
  @Expose() section?: PersonnelAttachmentSection;
  @Expose() key!: AttachmentAttrKey;
  @Expose() signedAt?: string;
}

@Exclude()
export class AttachmentModel extends BaseModel {
  /**
   * Primary ID
   *
   * Null when create
   */
  @Expose() @Default(null) id!: number | null;
  @Expose() drive!: 'azure' | 's3';
  @Expose() name!: string;
  @Expose() contentType!: string;
  @Expose() keyPath!: string;
  @Expose() @Type(() => AttachmentAttrModel) attrs!: AttachmentAttrModel;
}

@Exclude()
export class MultiAttachmentModel extends BaseModel {
  @Expose() @Default([]) files!: AttachmentModel[];
}

@Expose()
export class AttachmentControlModel extends BaseModel {
  @Expose()
  @Type(() => Map<string, UploadFileModel>)
  @Default(() => new Map<string, UploadFileModel>())
  files!: UploadFileControl;
}
